import React from "react";
import { SideMenu } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { BsPlusLg } from "react-icons/bs";
const Input = styled("input")({
  display: "none",
});

let AboutUs = () => {
  return (
    <SideMenu>
      <div className="page-data-view-container">
        <br />
        <p className="page-form-heading">About Us</p>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
              <div>
                <label htmlFor="icon-button-file">
                  <Input accept="image/*" id="icon-button-file" type="file" />
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    className="icon-button-file"
                  >
                    <BsPlusLg color="#7C7C7C" size={30} />
                  </IconButton>
                </label>
              </div>
            </Grid>
            <Grid item xl={9} lg={9} md={9} sm={12} xs={12}>
              <div>
                <p className="upload-file-heading">upload about Banner Image</p>
                <div>
                  <span className="upload-file-heading">
                    important guidelines:
                  </span>
                  <span className="upload-file-supported-message">
                    1200 x 800 or 12:8 ratio.
                  </span>
                </div>
                <div>
                  <span className="upload-file-heading">suported formate:</span>
                  <span className="upload-file-supported-message">
                    .jpg, .jpeg, or .png
                  </span>
                </div>
                <Button className="upload-file-button" variant="text">
                  Upload Image
                </Button>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Title</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Enter title"
                />
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Description</p>
                <textarea
                  className="textarea"
                  placeholder="Enter about descriptions"
                  rows="20"
                  cols="40"
                ></textarea>
              </div>
            </Grid>
          </Grid>
        </Box>
        <Grid container spacing={2}>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <Button className="form-button" variant="text">
              Submit
            </Button>
          </Grid>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
        </Grid>
      </div>
    </SideMenu>
  );
};
export default AboutUs;
